import { signatureConstants, configConstants } from '../_constants';
import { signatureService } from '../_services';
import { utilityHelper } from '../_helpers';
/**
 * signatureActions
 *
 * @package                onboard
 * @subpackage             signatureActions
 * @category               Actions
 * @DateOfCreation         15 May 2019
 * @ShortDescription       This is responsible to handle all action related to change password
 */
export const signatureActions = {
    signatureUpdate,
    businessAssignConsentUpdate,
    resetState
};

/**
* @DateOfCreation        15 May 2019
* @ShortDescription      This function is responsible for submit the change password form
* @param                 JSON user, This contains full user input data 
* @return                JSON Object
*/
function signatureUpdate(passwordDetail) {
    return dispatch => {
        signatureService.signatureUpdate(passwordDetail)
            .then(
                response => { 
                    let responseData = response.data;
                    if(response.status === configConstants.SUCCESS_CODE){
                        utilityHelper.setUpdateUserInfo('resetPassword', false)
                        let successMsg = responseData.message;
                        dispatch(success(successMsg));
                    }else if(response.status === configConstants.BAD_REQUEST_CODE){
                        let errorMsg = responseData.message;
                        dispatch(failure(errorMsg));
                    }else if(response.status === configConstants.EXCEPTION_CODE){
                        let errorMsg = responseData.message;
                        dispatch(failure(errorMsg));
                    }else if(response.status === configConstants.UNAUTHENTICATE_CODE){
                        dispatch(unauthorize(responseData.message));
                    }else{
                        dispatch(failure(response));
                    }
                }
            ).catch(function (response) {
                dispatch(failure(response));
            });
    };
    
    // Actions defination that will perform according dispatch call and send data to reducer
    function success(success) { return { type  : signatureConstants.SIGNATURE_SUCCESS, success } }
    function failure(error)  { return { type  : signatureConstants.SIGNATURE_FAILURE, error } }
    function unauthorize(error) { return { type: configConstants.UNAUTHENTICATE, error } }
}

/**
* @DateOfCreation        28 May 2019
* @ShortDescription      This function is responsible to update the states and props
* @return                JSON Object
*/
function resetState(){
    return dispatch => { dispatch(request());}
    function request() { return { type: signatureConstants.SIGNATURE_RESET } }
}

/**
* @DateOfCreation        15 May 2019
* @ShortDescription      This function is responsible for submit the change password form
* @param                 JSON user, This contains full user input data 
* @return                JSON Object
*/
function businessAssignConsentUpdate() {
    return dispatch => {
        dispatch(request());
        signatureService.businessAssignConsentUpdate()
            .then(
                response => { 
                    let responseData = {"success":true,"data":null,"message":"Status updated"};
                    response.status = configConstants.SUCCESS_CODE; // Mocking response for testing
                    //let responseData = response.data;
                    if(response.status === configConstants.SUCCESS_CODE){
                        let successMsg = responseData.message;
                        dispatch(success(successMsg));
                    }else if(response.status === configConstants.BAD_REQUEST_CODE){
                        let errorMsg = responseData.message;
                        dispatch(failure(errorMsg));
                    }else if(response.status === configConstants.EXCEPTION_CODE){
                        let errorMsg = responseData.message;
                        dispatch(failure(errorMsg));
                    }else if(response.status === configConstants.UNAUTHENTICATE_CODE){
                        dispatch(unauthorize(responseData.message));
                    } else {
                        dispatch(failure(response));
                    }
                }
            ).catch(function (response) {
                dispatch(failure(response));
            });
    };
    
    // Actions defination that will perform according dispatch call and send data to reducer
    function request() { return { type  : signatureConstants.BUSINESS_ASSIGN_CONSENT_REQUEST } }
    function success(success) { return { type  : signatureConstants.BUSINESS_ASSIGN_CONSENT_SUCCESS, success } }
    function failure(error)  { return { type  : signatureConstants.BUSINESS_ASSIGN_CONSENT_FAILURE, error } }
    function unauthorize(error) { return { type: configConstants.UNAUTHENTICATE, error } }
}

